import { PayloadAction } from '@reduxjs/toolkit';
import { IRootState } from './types';

const reducers = {
  setManagerPermissions: (state: IRootState, action: PayloadAction<IRootState['managerPermissions']>) => ({
    ...state,
    managerPermissions: action.payload,
  }),
  setEmployeePermissions: (state: IRootState, action: PayloadAction<IRootState['managerPermissions']>) => ({
    ...state,
    employeePermissions: action.payload,
  }),
  setIsOpenIntegrationNav: (state: IRootState, action: PayloadAction<IRootState['isOpenIntegrationNav']>) => ({
    ...state,
    isOpenIntegrationNav: action.payload,
  }),
  setDorIntegration: (state: IRootState, action: PayloadAction<IRootState['dorIntegration']>) => ({
    ...state,
    dorIntegration: action.payload,
  }),
  setDorLocations: (state: IRootState, action: PayloadAction<IRootState['dorLocations']>) => ({
    ...state,
    dorLocations: action.payload,
  }),
  setIsOpenDorDialog: (state: IRootState, action: PayloadAction<IRootState['isOpenDorDialog']>) => ({
    ...state,
    isOpenDorDialog: action.payload,
  }),
  setIntegrations: (state: IRootState, action: PayloadAction<IRootState['integrations']>) => ({
    ...state,
    integrations: action.payload,
  }),
};

export {
  reducers,
};
